import { decodeJwtPayload } from './experience'

export const API_TOKEN_STORAGE_KEY = 'api_Token'

type StoredContactAuthResult =
  | {
      kind: 'ready'
      smartAuth: string
      jwtPayload: Record<string, unknown>
      jwtPreview: string
    }
  | { kind: 'expired'; jwtPayload: Record<string, unknown> }
  | { kind: 'missing' }

function isJwtExpired(payload: Record<string, unknown>): boolean {
  const exp = payload.exp
  if (typeof exp !== 'number') return true
  return Date.now() > exp * 1000
}

function jwtMatchesContactToken(payload: Record<string, unknown>, contactToken: string): boolean {
  return payload.token === contactToken
}

export function clearContactAuthStorage(): void {
  try {
    sessionStorage.removeItem(API_TOKEN_STORAGE_KEY)
    sessionStorage.removeItem('tenant_id')
    sessionStorage.removeItem('avs01')
  } catch {
    return
  }
}

export function readStoredContactAuth(contactToken: string): StoredContactAuthResult {
  let smartAuth: string | null
  try {
    smartAuth = sessionStorage.getItem(API_TOKEN_STORAGE_KEY)
  } catch {
    return { kind: 'missing' }
  }
  if (!smartAuth) return { kind: 'missing' }

  const jwtPayload = decodeJwtPayload(smartAuth)
  if (!jwtPayload) {
    clearContactAuthStorage()
    return { kind: 'missing' }
  }

  if (!jwtMatchesContactToken(jwtPayload, contactToken)) {
    return { kind: 'missing' }
  }

  if (isJwtExpired(jwtPayload)) {
    return { kind: 'expired', jwtPayload }
  }

  return {
    kind: 'ready',
    smartAuth,
    jwtPayload,
    jwtPreview: JSON.stringify(jwtPayload, null, 2),
  }
}
